import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
    return <section className="lkfr-empty-page"><span className="lkfr-eyebrow">Страница не найдена</span><h1>Здесь пока ничего нет</h1><p>Проверьте адрес или откройте нужный раздел в меню кабинета.</p><Link to="/" className="business-primary">На главную</Link></section>;
}
